import "./style.scss";
import Selector from "../common/selector";
import React from "react";

const PermissionDistrictRow = (props) => {
  const {
    districts,
    schools,
    districtChange,
    schoolChange,
    removeAction,
    permissionDistricts,
    permissionSchools,
    districtIndex,
    showDistricts,
    showSchools,
    canRemoveFirstRow
  } = props;

  const permissionRowRemove =  (index) =>  {
    return (
      <div className='permission-row-remove'>
        {((index === 0 && canRemoveFirstRow) || index !== 0) && <button name={`remove${index}`} className='remove-button' onClick={(e) => {e.preventDefault(); removeAction(index)}}>X</button>}
      </div>
    );
  }

  return  (<div className='permission-district-row'>
      <Selector
        name="district"
        label='District'
        value={(permissionDistricts[districtIndex]) ? permissionDistricts[districtIndex].id : ''}
        optionLabelField='name'
        optionValueField='id'
        changeAction={(newDistrict) => {districtChange(newDistrict, districtIndex)}}
        showLabel={true}
        items={districts}
        disabled={!showDistricts}
        hide={!showDistricts}
      />
      <Selector
        name="schools"
        label='School'
        value={(permissionSchools[districtIndex]) ? permissionSchools[districtIndex] : []}
        optionLabelField='name'
        optionValueField='id'
        changeAction={(selectedSchools) => {
          schoolChange(selectedSchools, districtIndex)
        }}
        showLabel={true}
        items={schools}
        disabled={!showSchools}
        hide={!showSchools}
        multiple={true}
      />
      {permissionRowRemove(districtIndex)}
    </div>
  );
}

export default PermissionDistrictRow;